export default (state = {}, action) => {
    switch (action.type) {
      case 'LOGIN':
        return {
          uid: action.user.uuid,
          email: action.user.email,
          name: action.user.name,
          token: action.user.token,
          loc_id: action.user.loc_id,
          organisation: action.user.organisation
        };
      case 'LOGOUT':
        return {
          uid: undefined
        };
      default:
        return state;
    }
  };
  